<template>
  <div class="control_bar top">
    <div class="search">
      <input
        type="text"
        class="search_field"
        placeholder="所属名から検索"
        v-model="inputValue"
      />
      <input
        type="button"
        :value="search"
        class="search_button"
        @click="belongFindAction"
      />
    </div>
    <controller
      :dispItems="dispItems"
      :allItems="posts"
      :router="router"
      @remove="remove"
      @import="importModal"
      @exportFile="exportFile"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
    <div class="import_modal_window" v-if="showImportModal">
      <importModalWindow @close="closeModal" @import="importFile">
      </importModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import importModalWindow from '../modalWindow/importModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      inputValue: '',
      search: '検索',
      showFinishModal: false,
      finishWord: '',
      router: '/belongs/add',
      showloadingModal: false,
      showImportModal: false,
      records: [],
      csvData: [],
      confirmed: ''
    }
  },
  computed: {
    posts() {
      return this.$store.state.belongs.posts
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedPostList() {
      return this.$store.state.belongs.selectedPostList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow,
    importModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showImportModal = false
      this.showFinishModal = false
    },
    async remove(e) {
      let selectedPostList = this.selectedPostList.map(post => {
        let postId = post.postId
        return {postId}
      })
      this.showloadingModal = true
      try {
        await this.$store.dispatch('belongs/deletePosts', selectedPostList)
        this.$store.dispatch('belongs/clearSelectedPostList')
        this.finishWord = '対象の所属を削除しました。'
        this.showFinishModal = true
        // 削除ボタン押下時は詳細画面を初期化する
        if (location.pathname !== '/belongs') {
          this.$router.push('/belongs')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_200003
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0129') {
            this.finishWord =
              this.errorMsg.MSGCRC0129.name +
              this.errorMsg.MSGCRC0129.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.finishWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.finishWord =
              this.errorMsg.MSGCRC0038.name +
              this.errorMsg.MSGCRC0038.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0038'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0038.name +
            this.errorMsg.MSGCRC0038.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    belongFindAction(event) {
      this.$emit('input-event', 0, this.inputValue)
      this.confirmed = this.inputValue
    },
    importModal(e) {
      this.records = e
      this.showImportModal = true
    },
    async importFile(e) {
      e = this.records
      this.showImportModal = false
      this.showloadingModal = true
      var createList = []
      for (let i = 0; i < e.length; i++) {
        let obj = {}
        let header = this.$store.state.error.exportTitle.belongTitle.replace(
          '\r\n',
          ''
        )
        let data = e[i].replace('\r', '')
        if (data !== header) {
          this.csvSplit(data)
          var csvArrayList = this.csvData
          this.csvData = []
          if (
            csvArrayList.length !==
            this.$store.state.error.importErrorNumber.importPostNumber
          ) {
            let eventNumber = this.$store.state.error.errorCode.errorCode_200007
            let eventType = 9
            let reason = 'MSGCRC0008'
            try {
              this.$store.dispatch('masters/writeLog', {
                eventNumber,
                eventType,
                reason
              })
            } catch (error) {}
            this.finishWord =
              this.errorMsg.MSGCRC0008.name +
              this.errorMsg.MSGCRC0008.beforeValue +
              (i + 1) +
              this.errorMsg.MSGCRC0008.afterValue +
              'エラーコード：{' +
              eventNumber +
              '}'
            this.showFinishModal = true
            this.showloadingModal = false
            return
          }
          obj['postId'] = csvArrayList[0]
          obj['postCode'] = csvArrayList[1]
          obj['postName'] = csvArrayList[2].replace(/[\r\n]/g, match => {
            if (match === '\r') {
              return ''
            } else {
              return ''
            }
          })
          obj['parentPostId'] = csvArrayList[3]
          obj['parentPostCode'] = csvArrayList[4]
          obj['parentPostName'] = csvArrayList[5].replace(/[\r\n]/g, match => {
            if (match === '\r') {
              return ''
            } else {
              return ''
            }
          })
          obj['fileRowCount'] = String(i + 1)
          createList.push(obj)
        }
      }
      if (location.pathname !== '/belongs') {
        this.$router.push('../belongs')
      }
      try {
        await this.$store.dispatch('belongs/importPosts', createList)
        this.$emit('list-reload')
        this.finishWord = 'インポートしました。'
        this.showFinishModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_200009
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message.split(',')
          if (errorMessage[0] === 'MSGCRC0033') {
            this.finishWord =
              this.errorMsg.MSGCRC0033.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0033.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0101') {
            this.finishWord =
              this.errorMsg.MSGCRC0101.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0101.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0147') {
            this.finishWord =
              this.errorMsg.MSGCRC0147.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0147.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0148') {
            this.finishWord =
              this.errorMsg.MSGCRC0148.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0148.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0149') {
            this.finishWord =
              this.errorMsg.MSGCRC0149.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0149.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0150') {
            this.finishWord =
              this.errorMsg.MSGCRC0150.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0150.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0151') {
            this.finishWord =
              this.errorMsg.MSGCRC0151.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0151.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0152') {
            this.finishWord =
              this.errorMsg.MSGCRC0152.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0152.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0153') {
            this.finishWord =
              this.errorMsg.MSGCRC0153.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0153.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0154') {
            this.finishWord =
              this.errorMsg.MSGCRC0154.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0154.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0173') {
            this.finishWord =
              this.errorMsg.MSGCRC0173.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0173.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0174') {
            this.finishWord =
              this.errorMsg.MSGCRC0174.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0174.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0175') {
            this.finishWord =
              this.errorMsg.MSGCRC0175.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0175.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0176') {
            this.finishWord =
              this.errorMsg.MSGCRC0176.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0176.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0177') {
            this.finishWord =
              this.errorMsg.MSGCRC0177.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0177.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0178') {
            this.finishWord =
              this.errorMsg.MSGCRC0178.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0178.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0185') {
            this.finishWord =
              this.errorMsg.MSGCRC0185.name +
              (Number(errorMessage[1]) + 1) +
              this.errorMsg.MSGCRC0185.beforeValue +
              errorMessage[1] +
              this.errorMsg.MSGCRC0185.afterValue +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0201') {
            this.finishWord =
              this.errorMsg.MSGCRC0201.name +
              errorMessage[1] +
              '行目：' +
              this.errorMsg.MSGCRC0201.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage[0] === 'MSGCRC0264') {
            this.finishWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.finishWord =
              this.errorMsg.MSGCRC0039.name +
              this.errorMsg.MSGCRC0039.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage[0] + ' '
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0039'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0039.name +
            this.errorMsg.MSGCRC0039.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    },
    csvSplit(line) {
      let c = ''
      let s = ''
      let before = ''
      let singleQuoteFlg = false
      let escapeFlg = false
      for (let i = 0; i < line.length; i++) {
        before = c
        c = line.charAt(i)
        if (c === ',' && !singleQuoteFlg) {
          this.csvData.push(s)
          s = ''
        } else if (c === ',' && singleQuoteFlg) {
          s = s + c
        } else if (c === '"') {
          if (before === '"' && escapeFlg) {
            s = s + c
            escapeFlg = false
          } else {
            if (i !== line.lengt - 1) {
              // 最終文字ではない場合
              if (line.charAt(i + 1) === '"' && singleQuoteFlg) {
                escapeFlg = true
              } else {
                singleQuoteFlg = !singleQuoteFlg
              }
            } else {
              singleQuoteFlg = !singleQuoteFlg
            }
          }
        } else {
          s = s + c
        }
      }
      if (line.charAt(line.length - 1) === ',') {
        // csvファイルの行の最終文字が , の場合
        this.csvData.push('')
      } else {
        this.csvData.push(s)
      }
    },
    async exportFile() {
      var selectedPostIdList = this.selectedPostList.map(post => {
        return {postId: post.postId}
      })
      this.showloadingModal = true
      try {
        const params = {selectedPostIdList: selectedPostIdList}
        if (selectedPostIdList.length === 0) {
          params.searchWord = this.confirmed ? this.confirmed : ''
        }
        await this.$store.dispatch('belongs/setExportData', params)

        const exportList = this.$store.state.belongs.exportData
        let result = this.$store.state.error.exportTitle.belongTitle
        for (let i = 0; i < exportList.length; i++) {
          for (let k of Object.keys(exportList[i])) {
            if (!exportList[i][k]) {
              exportList[i][k] = ''
            }
          }
          result +=
            exportList[i].postId +
            ',' +
            exportList[i].postCode +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].postName) +
            ',' +
            exportList[i].parentPostId +
            ',' +
            exportList[i].parentPostCode +
            ',' +
            this.exportSetDoubleQuotation(exportList[i].parentPostName) +
            '\r\n'
        }
        if (result === '') {
          let eventNumber = this.$store.state.error.errorCode.errorCode_200008
          let eventType = 9
          let reason = 'MSGCRC0006'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0006.name +
            this.errorMsg.MSGCRC0006.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        let csv = ''
        csv += result
        let link = document.createElement('a')
        let bom = new Uint8Array([0xef, 0xbb, 0xbf])
        let blob
        if (window.navigator.msSaveOrOpenBlob) {
          // for ie
          blob = new Blob([bom, csv], {type: 'text/csv'})
          window.navigator.msSaveOrOpenBlob(blob, '所属一覧.csv')
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.webkitURL && window.webkitURL.createObjectURL) {
          // for chrome (and safari)
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '所属一覧.csv')
          link.setAttribute('href', window.webkitURL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else if (window.URL && window.URL.createObjectURL) {
          // for firefox
          blob = new Blob([bom, csv], {type: 'text/csv'})
          link.setAttribute('download', '所属一覧.csv')
          link.setAttribute('href', window.URL.createObjectURL(blob))
          link.click()
          this.finishWord = 'エクスポートしました。'
          this.showFinishModal = true
        } else {
          let eventNumber = this.$store.state.error.errorCode.errorCode_200005
          let eventType = 9
          let reason = 'MSGCRC0007'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          this.finishWord =
            this.errorMsg.MSGCRC0007.name +
            this.errorMsg.MSGCRC0007.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          this.showFinishModal = true
          this.showloadingModal = false
          return
        }
        window.URL.revokeObjectURL(link)
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_200006
        let eventType = 3
        let reason = ''
        if (error.response) {
          reason = 'MSGCRC0040 '
          this.finishWord =
            this.errorMsg.MSGCRC0040.name +
            this.errorMsg.MSGCRC0040.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
        this.showloadingModal = false
        return
      }
      this.showloadingModal = false
    },
    exportSetDoubleQuotation(value) {
      let c = ''
      let s = ''
      let doubleQuoteFlg = false
      // ダブルクォーテーションのエスケープ処理
      for (let i = 0; i < value.length; i++) {
        c = value.charAt(i)
        if (c === '"') {
          doubleQuoteFlg = true
          s = s + '"' + c
        } else {
          s = s + c
        }
      }
      if (doubleQuoteFlg) {
        s = '"' + s + '"'
      }
      // カンマがある場合、ダブルクォーテーションで囲む
      if (s.indexOf(',') >= 0 && !doubleQuoteFlg) {
        return '"' + s + '"'
      }
      return s
    }
  }
}
</script>

<style scoped>
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/belongs/controlbar.vue